import React from 'react';

const DateTimeInputCoverings = ({ onClick }) => (
    <div className='input-group' >
        <div className='input-group-prepend'>
            <div className='btn btn-outline-secondary border-0' onClick={onClick}>
                <span className='oi oi-calendar'></span>
            </div>
        </div>
    </div>
);

export default DateTimeInputCoverings;
